export default "__VITE_PUBLIC_ASSET__c327022c__"